import { QuestionType } from '../models/questionType.enum';

export interface QuestionTypeMeta {
  label: string;
  icon: string;
  hasChoices: boolean;
  hasPlaceholder: boolean;
  hasMinMax: boolean;
  hasMandatory: boolean;
//   multiline: boolean;
}

export const QUESTION_TYPE_METAS: Record<QuestionType, QuestionTypeMeta> = {
  [QuestionType.Numeric]: { label: 'Numeric', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true },
  [QuestionType.Verbatim]: { label: 'Verbatim', icon: 'notes', hasChoices: false, hasPlaceholder: true, hasMinMax: false, hasMandatory: true },
  [QuestionType.MultipleChoice]: { label: 'Multiple Choice', icon: 'check_box', hasChoices: true, hasPlaceholder: false, hasMinMax: true, hasMandatory: true },
  [QuestionType.ThankYouMessage]: { label: 'ThankYouMessage', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: false, hasMandatory: false},
  [QuestionType.Boolean]: { label: 'Boolean', icon: 'toggle_on', hasChoices: false, hasPlaceholder: false, hasMinMax: false, hasMandatory: true},
  [QuestionType.ContactForm]: { label: 'ContactForm', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.DropDown]: { label: 'DropDown', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.Message]: { label: 'Message', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.MultiFields]: { label: 'MultiFields', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.FileInput]: { label: 'FileInput', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.ImageMap]: { label: 'ImageMap', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.Ranking]: { label: 'Ranking', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.Group]: { label: 'Group', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.Phone]: { label: 'Phone', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.Country]: { label: 'Country', icon: 'pin', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.CustomizedI]: { label: 'CustomizedI', icon: 'directions_car', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.CustomizedII]: { label: 'CustomizedII', icon: 'directions_car', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
  [QuestionType.BrandModel]: { label: 'BrandModel', icon: 'directions_car', hasChoices: false, hasPlaceholder: false, hasMinMax: true, hasMandatory: true},
};

export const QUESTION_TYPE_OPTIONS: QuestionType[] =
  Object.values(QuestionType).filter(
    (value): value is QuestionType => typeof value === 'number'
  );

export function getQuestionTypeLabel(type: QuestionType): QuestionTypeMeta['label'] {
  return QUESTION_TYPE_METAS[type].label ?? 'Unknown';
}